import api from "../../../../services/api";

const baseUrl = process.env.REACT_APP_PROVIDERDOCUMENT;

export const sendDateRelationFile = async (file: FormData) => {
  try {
    const { data } = await api.put(
      baseUrl + "/providerProducts/relationshipDate",
      file,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );
    return data;
  } catch (err) {
    return err;
  }
};
